import { Component, OnInit, Input, Output } from "@angular/core";
import { SesionService } from "src/app/services/sesion.service";
import { WebServicesService } from "../../services/web-services.service";
import { EventEmitter } from '@angular/core';
import { Texto_sitio } from "src/assets/text_site";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { environment } from "src/environments/environment";
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-menu-lateral-celular',
  templateUrl: './menu-lateral-celular.component.html',
  styleUrls: ['./menu-lateral-celular.component.scss'],
  standalone: true,
  providers: [
    SesionService,
    WebServicesService,
    Texto_sitio,
  ],
  imports: [
    CommonModule, 
    RouterModule,
    TranslateModule
  ]
})
export class MenuLateralCelularComponent implements OnInit {
  @Input() step: any;
  @Output("cerrarMenuLlave") evento2: EventEmitter<any> = new EventEmitter();
  todoElIdioma: any;
  lang: string = 'es';
  checkComplLogin: boolean = false;
  constructor(public sesion: SesionService, private translateService: TranslateService, public ws: WebServicesService, private texto_sitio: Texto_sitio, private activatedRoute: ActivatedRoute,) {
    this.todoElIdioma = this.texto_sitio.spain;
    this.lang = this.translateService.currentLang;
    // esto es para ocultar el mapa del sitio
    this.checkComplementForLogin();
  }

  ngOnInit(): void {
    this.sesion.getUser();
  }

  irFacebook() {
    window.open(environment.redes.facebook, "_blank");
  }

  irTwiter() {
    window.open(environment.redes.twitter, "_blank");
  }

  irInstagram() {
    window.open(environment.redes.instagram, "_blank");
  }

  accion() {
    this.evento2.emit("valor2");
  }

  /**
   * Checkea los complementos para poder mostrar el boton de ingresar al login
   */
  checkComplementForLogin() {
    this.checkComplLogin = this.ws.newComplemt =='pasajes' || this.ws.newComplemt =='transfer' || this.ws.newComplemt =='movired'? true: false;
  }
}
